export const RecognitionRuns = {
  en: {
    'Recognition Runs': 'Recognition Runs',
    'Run manually': 'Run manually',
    'Run at': 'Run at',
    Job: 'Job',
    Status: 'Status',
    'Finished at': 'Finished at',
    Processed: 'Processed',
    Failures: 'Failures',
    'Triggered by': 'Triggered by',
    triggered_by_system: 'System',
    kind_monthly_recognition: 'Monthly recognition',
    kind_card_breakage: 'Card breakage',
    kind_service_breakage: 'Service breakage',
    kind_certificate_breakage: 'Certificate breakage',
    status_running: 'Running',
    status_completed: 'Completed',
    status_failed: 'Failed',
  },
  uk: {
    'Recognition Runs': 'Визнання виручки',
    'Run manually': 'Запустити вручну',
    'Run at': 'Запуск',
    Job: 'Завдання',
    Status: 'Статус',
    'Finished at': 'Завершено о',
    Processed: 'Оброблено',
    Failures: 'Збої',
    'Triggered by': 'Ким запущено',
    triggered_by_system: 'Система',
    kind_monthly_recognition: 'Щомісячне визнання',
    kind_card_breakage: 'Згоряння карток',
    kind_service_breakage: 'Згоряння послуг',
    kind_certificate_breakage: 'Згоряння сертифікатів',
    status_running: 'Виконується',
    status_completed: 'Завершено',
    status_failed: 'Помилка',
  },
};
